import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PesquisarJornalPaginadoState } from "../../reducers/Pesquisa/pesquisar-jornal-paginado.reducer";

export const selectPesquisarJornalPaginadoState = createFeatureSelector<PesquisarJornalPaginadoState>('pesquisarJornalPaginado');

export const selectDadosPesquisarJornalPaginado = createSelector(
    selectPesquisarJornalPaginadoState,
    (state: PesquisarJornalPaginadoState) => state.response
);

export const selectPesquisarJornalPaginado = createSelector(
  selectPesquisarJornalPaginadoState,
  (state: PesquisarJornalPaginadoState) => state
);

export const selectErrosPesquisarJornalPaginado = createSelector(
    selectPesquisarJornalPaginadoState,
    (state: PesquisarJornalPaginadoState) => state.error
);
